import httpManager from "../../util/common";
import china_area_code from "../../../static/json/100000_full_geo.json"
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
let pollution_map = {
  name: 'pollution-map',
  data: () => {
    return {
      data: [],
      area_data: {},
      monthLength: null,
      report_year: null,
      report_year_options: [],
      report_type: 'annually',
      report_type_options: [
        {label: '年度', value: 'annually'},
        {label: '季度', value: 'quarterly'},
        {label: '月度', value: 'monthly'}],
      reporting_val: null,
      reporting_val_options: [],
      month_options: [
        {label: '01月', value: '01'},
        {label: '02月', value: '02'},
        {label: '03月', value: '03'},
        {label: '04月', value: '04'},
        {label: '05月', value: '05'},
        {label: '06月', value: '06'},
        {label: '07月', value: '07'},
        {label: '08月', value: '08'},
        {label: '09月', value: '09'},
        {label: '10月', value: '10'},
        {label: '11月', value: '11'},
        {label: '12月', value: '12'}
      ],
      reporting_period: null,
      pollutant: 'particulates',
      pollutant_options: [
        {label: '颗粒物（吨）', value: 'particulates'},
        {label: 'NOx（吨）', value: 'nox'},
        {label: 'SO2（吨）', value: 'so2'},
        {label: 'VOCs（吨）', value: 'vocs'},
        {label: '氨氮（吨）', value: 'ammonia_nitrogen'},
        {label: 'CODcr（吨）', value: 'codcr'},
        {label: '总磷（吨）', value: 'total_phosphorus'},
        {label: '总氮（吨）', value: 'total_nitrogen'}
      ],
      result_list: [],
      colorMap: {
        particulates: [
          {min: 0, max: 1600, color: '#97FF2F'},
          {min: 1600, max: 3000, color: '#FFFF6D'},
          {min: 3000, max: 5500, color: '#FFB837'},
          {min: 5500, max: 7600, color: '#FF4747'},
          {min: 7600, max: 10000, color: '#B40000'},
          {min: 10000, max: 18000, color: '#7E0000'},
          {min: 18000, max: null, color: '#460000'}
        ],
        nox: [
          {min: 0, max: 3000, color: '#97FF2F'},
          {min: 3000, max: 6000, color: '#FFFF6D'},
          {min: 6000, max: 11000, color: '#FFB837'},
          {min: 11000, max: 14000, color: '#FF4747'},
          {min: 14000, max: 18000, color: '#B40000'},
          {min: 18000, max: 23000, color: '#7E0000'},
          {min: 23000, max: null, color: '#460000'}
        ],
        so2: [
          {min: 0, max: 1600, color: '#97FF2F'},
          {min: 1600, max: 4000, color: '#FFFF6D'},
          {min: 4000, max: 6000, color: '#FFB837'},
          {min: 6000, max: 8000, color: '#FF4747'},
          {min: 8000, max: 12000, color: '#B40000'},
          {min: 12000, max: 18000, color: '#7E0000'},
          {min: 18000, max: null, color: '#460000'}
        ],
        vocs: [
          {min: 0, max: 15, color: '#97FF2F'},
          {min: 15, max: 80, color: '#FFFF6D'},
          {min: 80, max: 200, color: '#FFB837'},
          {min: 200, max: 500, color: '#FF4747'},
          {min: 500, max: 1500, color: '#B40000'},
          {min: 1500, max: 3000, color: '#7E0000'},
          {min: 3000, max: null, color: '#460000'}
        ],
        ammonia_nitrogen: [
          {min: 0, max: 15, color: '#97FF2F'},
          {min: 15, max: 80, color: '#FFFF6D'},
          {min: 80, max: 160, color: '#FFB837'},
          {min: 160, max: 300, color: '#FF4747'},
          {min: 300, max: 660, color: '#B40000'},
          {min: 660, max: 1600, color: '#7E0000'},
          {min: 1600, max: null, color: '#460000'}
        ],
        codcr: [
          {min: 0, max: 1600, color: '#97FF2F'},
          {min: 1600, max: 3000, color: '#FFFF6D'},
          {min: 3000, max: 6000, color: '#FFB837'},
          {min: 6000, max: 10000, color: '#FF4747'},
          {min: 10000, max: 13000, color: '#B40000'},
          {min: 13000, max: 17000, color: '#7E0000'},
          {min: 17000, max: null, color: '#460000'}
        ],
        total_phosphorus: [
          {min: 0, max: 2, color: '#97FF2F'},
          {min: 2, max: 15, color: '#FFFF6D'},
          {min: 15, max: 50, color: '#FFB837'},
          {min: 50, max: 100, color: '#FF4747'},
          {min: 100, max: 200, color: '#B40000'},
          {min: 200, max: 1800, color: '#7E0000'},
          {min: 1800, max: null, color: '#460000'}
        ],
        total_nitrogen: [
          {min: 0, max: 20, color: '#97FF2F'},
          {min: 20, max: 400, color: '#FFFF6D'},
          {min: 400, max: 1500, color: '#FFB837'},
          {min: 1500, max: 3000, color: '#FF4747'},
          {min: 3000, max: 6000, color: '#B40000'},
          {min: 6000, max: 18000, color: '#7E0000'},
          {min: 18000, max: null, color: '#460000'}
        ]
      },
      map: null,   //地图对象
      geo_layer: null,  //地域块对象
      info_control: null, //地图右上角信息控件
      myloding: false,
      divloading: false
    }
  },
  mounted () {
    this.generateReportYearOptions()
    this.generateReportingPeriodOptions()
    this.clearData()
    this.getPollutantAreaMapData()
  },
  methods: {
    generateReportYearOptions () {
      let date = new Date()
      let year = Number(date.getFullYear())
      this.report_year = year
      this.report_year_options = []
      for (let i = 2017; i <= year; i++) {
        this.report_year_options.push({label: String(i) + '年', value: i})
      }
    },
    generateReportingPeriodOptions () {
      if (this.report_type === 'annually') {
        this.reporting_val_options = []
        this.reporting_val = null
      }
      if (this.report_type === 'monthly') {
        this.reporting_val_options = this.month_options
        this.reporting_val = '01'
      }
      if (this.report_type === 'quarterly') {
        this.reporting_val_options = [
          {label: '第一季度', value: 'Q1'},
          {label: '第二季度', value: 'Q2'},
          {label: '第三季度', value: 'Q3'},
          {label: '第四季度', value: 'Q4'}
        ]
        this.reporting_val = 'Q1'
      }
    },
    getPollutantAreaMapData () {
      let self = this
      self.data = []
      self.divloading = true
      let params = new Map()
      if (self.report_type === 'annually') {
        self.reporting_period = self.report_year + '年'
      } else if (self.report_type === 'monthly') {
        self.reporting_period = self.report_year + '年' + self.reporting_val + '月'
      } else if (self.report_type === 'quarterly') {
        self.reporting_period = self.report_year + '年' + self.reporting_val
      }
      params.set('reporting_period', self.reporting_period)
      params.set('pollutant', self.pollutant)
      if (params.length < 2) {
        return
      }
      httpManager('pollution_statistics_execution', params, null, null, null)
        .then(response => {
          self.data = response.data.data
          self.area_data = {}
          if (self.data.length > 0) {
            self.data.forEach(function (value, index, array) {
              self.area_data[value['district_code']] = value
            })
          }
          self.data = response.data.data
          self.divloading = false
          self.leafletMap()
        })
        .catch(error => {
          console.log(error)
          self.divloading = false
        })
    },
    leafletMap () {
      if( !this.map ) {
        this.map = L.map('pollution-area-map', {
          center: [40, 115],
          zoom: 4,
          zoomControl: false,
          doubleClickZoom: false,
        })

        this.initInfoControl()
        this.info_control.addTo(this.map)
        // 读取第三方地图，只需将以下代码取消注释即可
        /*
        let map_url = ''  // 读取第三方的地图url，请详细阅读第三方协议设置map_url 
        L.tileLayer(map_url, {
            id: 'mapbox/light-v9',
            attribution: `Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors,
            Imagery &copy; <a href="https://www.mapbox.com">Mapbox</a>
            `,
            tileSize: 512,
            zoom: 5,
            zoomOffset: -1,
            zoomControl: false,
            doubleClickZoom: false,
            attributionControl: false,
            accessToken: ''  // 可在此配置第三方地图的token，减小map_url的长度
        }).addTo(this.map);
        */
        
      } else {
        this.map.removeLayer(this.geo_layer)
      }
      this.geo_layer = L.geoJSON(china_area_code, {
        style: this.style,
        onEachFeature: this.onEachFeature
      }).addTo(this.map)
    },
    // 地图获取颜色，在style中调用
    getColor(adcode) {
      let self = this
      let color = '#fdfdfc'
      if(self.area_data.hasOwnProperty(adcode)){
        let gdp = self.area_data[adcode][self.pollutant]
        if (self.report_type === 'annually') {
          self.monthLength = 12
        } else if (self.report_type === 'monthly') {
          self.monthLength = 1
        } else if (self.report_type === 'quarterly') {
          self.monthLength = 3
        }
        self.colorMap[self.pollutant].forEach((element) => {
          let min_value = element['min'] * self.monthLength
          if(gdp > min_value) {
            if(element['max'] && gdp < element['max'] * self.monthLength) {
              color = element['color']
            } else if(element['max'] === null) {
              color = element['color']
            }
          }
        })
      }
      return color;
    },
    // 地图获取样式
    style(feature) {
      return {
        fillColor: this.getColor(feature.properties.adcode),
        weight: 2,
        opacity: 1,
        color: '#7e7e7b',
        dashArray: '3',
        fillOpacity: 0.7
      }
    },
    // 初始化地图右上角信息控件
    initInfoControl() {
      this.info_control = L.control()
      this.info_control.onAdd = function(map) {
        this._div = L.DomUtil.create('div', 'map-info'); // create a div with a class "info"
        this.update();
        return this._div;
      }
      this.info_control.update = function(props) {
        let name = props? props.name : "中华人民共和国"
        this._div.innerHTML = '<h4>China</h4>' + 
          '<b>' + name +'</b><br />'
      }
    },
    // 地图相关事件
    onEachFeature(feature, layer) {
      layer.on({
        mouseover: this.highlightFeature,
        mouseout: this.resetHighlight,
        click: this.zoomToFeature
      })
    },
    // 地图触碰高亮，在onEachFeature中调用
    highlightFeature(e) {
      var layer = e.target
      
      layer.setStyle({
        weight: 3,
        color: '#fff',
        dashArray: '',
        fillOpacity: 0.7
      })
      if(!L.Browser.ie && !L.Browser.opera && !L.Browser.edge){
        layer.bringToFront()
      }

      this.info_control.update(layer.feature.properties)
    },
    // 地图移除高亮，在onEachFeature中调用
    resetHighlight(e) {
      this.geo_layer.resetStyle(e.target);
      this.info_control.update()
    },
    // 地图点击放大板块，在onEachFeature中调用
    zoomToFeature(e) {
      this.map.fitBounds(e.target.getBounds())
    },
    clearData () {
      this.data = []
      let date = new Date()
      this.report_year = String(date.getFullYear())
      this.pollutant = 'particulates'
      this.report_type = 'annually'
      this.reporting_val = null
      // this.reporting_val = String(date.getMonth()).padStart(2, '0')
      // this.reporting_period = this.report_year + '年' + this.reporting_val + '月'
      this.reporting_period = this.report_year + '年'
    }
  }
}
export default pollution_map



// WEBPACK FOOTER //
// ./src/pollution/js/pollution_map.js